module.exports = __webpack_public_path__ + "static/media/carousel-arrow-large-right.7586ae23.svg";